import React, { useContext } from 'react';
import { CircularProgress } from '@material-ui/core';

import { HabitatsContext } from 'containers/Habitats';

const Progress = () => {
  const { refs, state } = useContext(HabitatsContext);
  const { animationLoading } = state;
  const { mapRef } = refs;
  if (animationLoading && mapRef.current) {
    return (
      <div
        style={{
          // zIndex: '',
          position: 'absolute',
          left: '50%',
          top: '50%',
        }}
      >
        <CircularProgress color="primary" size={40} />
      </div>
    );
  }
  return null;
};

export default Progress;
